export const formatMaskedPan = value => {
  // Remove all non-digit characters
  const digitsOnly = value.replace(/\D/g, '')
  // If less than or equal to 6 digits, return as is
  if (digitsOnly.length <= 6) {
    return digitsOnly
  }
  // If between 6 and 10 digits
  if (digitsOnly.length <= 10) {
    const firstSix = digitsOnly.slice(0, 6)
    const remaining = digitsOnly.slice(6)
    const asterisks = '*'.repeat(6)
    return `${firstSix}${asterisks}${remaining}`
  }
  // If more than 10 digits, limit to 10 and format
  const firstSix = digitsOnly.slice(0, 6)
  const lastFour = digitsOnly.slice(6, 4)
  const asterisks = '*'.repeat(6)
  return `${firstSix}${asterisks}${lastFour}`
}

export const ISOformatMaskedPan = value => {
  // Remove all non-digit characters
  const digitsOnly = value.replace(/\D/g, '')
  // If less than or equal to 6 digits, return as is
  if (digitsOnly.length <= 6) {
    return digitsOnly
  }
  // If between 6 and 10 digits
  if (digitsOnly.length <= 10) {
    const firstSix = digitsOnly.slice(0, 6)
    const remaining = digitsOnly.slice(6)
    const asterisks = '*'.repeat(9)
    return `${firstSix}${asterisks}${remaining}`
  }
  // If more than 10 digits, limit to 10 and format
  const firstSix = digitsOnly.slice(0, 6)
  const lastFour = digitsOnly.slice(6, 4)
  const asterisks = '*'.repeat(9)
  return `${firstSix}${asterisks}${lastFour}`
}
